import axios from 'axios';
import { API } from '@/utils/api';

/**
 * Tworzy realną, opublikowaną stronę (hodowla/firma) z danych kreatora /stworz
 * i zwraca ścieżkę publiczną (z ?nowa=1). Używane w StworzCreator (happy path)
 * oraz StworzFinish (dokończenie po zalogowaniu istniejącego usera).
 */
export async function provisionFromDraft(draft, token, coverUrl = '') {
  const headers = { Authorization: `Bearer ${token}` };
  if (draft.type === 'hodowla') {
    const { data } = await axios.post(`${API}/kennels/from-creator`, {
      name: draft.name,
      breeds: draft.breeds || [],
      city: draft.city,
      organization: draft.organization,
      description: draft.description,
      phone: draft.phone,
      email: draft.email,
      cover_image: coverUrl,
    }, { headers });
    return `/hodowla/${data.slug}?nowa=1`;
  }
  const services = (draft.services || '')
    .split(',').map((s) => s.trim()).filter(Boolean).map((s) => ({ name: s }));
  const { data } = await axios.post(`${API}/business/`, {
    name: draft.name,
    industry: draft.industryName,
    city: draft.city,
    description: draft.description,
    phone: draft.phone,
    email: draft.email,
    services,
    cover_photo: coverUrl,
    logo: coverUrl,
    is_published: true,
    show_in_catalog: true,
  }, { headers });
  return `/firma/${data.slug}?nowa=1`;
}
